(function(){

  var amenities = {
    dom: function() {
      this.$toggleAmenity = $('#toggle-amenity');
      this.$toggleAmenityGroup = $('[data-js-hook="toggle-amenity-group"]');
      this.$hiddenAmenity = $('[data-js-hook="hidden-amenity"]');
    },

    toggleAmenities: function() {
      var self = this;

      this.$toggleAmenityGroup.click(function(e){
        e.preventDefault();
        var $hiddenAmenities = self.$hiddenAmenity.filter('[data-amenity-group=' + $(this).data('amenity-group') + ']');
        var $this = $(this);
        $(this).toggleClass('amenity-a__expand--expanded');
        $hiddenAmenities.slideToggle(200, function(){
          var visible = $hiddenAmenities.first().is(':visible');
          $this.find('[data-js-hook="expand-icon"]').html(visible ? '&times;' : '+');
          $this.find('[data-js-hook="expand-verbiage"]').html(visible ? 'Show Less' : 'Show More');
        });
      });

      this.$toggleAmenity.click(function(e){
        e.preventDefault();
        var $this = $(this);
        self.$hiddenAmenity.slideToggle(200, function(){
          var visible = self.$hiddenAmenity.first().is(':visible');
          $this.text(visible ? 'Show Less' : 'Show More');
        });
      });
    },

    ready: function() {
      this.dom();
      this.toggleAmenities();
    }
  }

  $(function(){
    amenities.ready();
  });

})();

/* -----------------------------------------------------------------
  CONFIG ELEMENT HELPER
----------------------------------------------------------------- */
function _e(selector) {
  return new config.element._instance(selector);
}

/* -----------------------------------------------------------------
  CONFIG OBJECT
----------------------------------------------------------------- */
var config = {
  siteUrl: config.siteUrl,
  mobileBreak: 808
};

/* -----------------------------------------------------------------
  CONFIG WOW OBJECT
  Remove when migrating config object to site not using WOW for
  animations.
----------------------------------------------------------------- */
if (typeof WOW == 'function') {
  config.wowInit = function() {
    config.wow = new WOW();
    config.wow.destroy = function() {
      $('.wow').removeClass('wow');
    }
  }();
}

/* -----------------------------------------------------------------
  CONFIG REQUEST OBJECT
----------------------------------------------------------------- */
config.request = {
  _cache: [],

  _request: function(type, url, dataOrCallback, callback, dataType) {

    if (dataOrCallback instanceof Object || typeof dataOrCallback == 'string') {
      var data = dataOrCallback;
    } else {
      var data = false;
      console.log(dataOrCallback);
      callback = dataOrCallback;
    }

    var cacheIndex = data ? type + ':' + url + '?' + $.param(data) : type + ':' + url;
    var cache = this._cache[cacheIndex];

    if (cache) {
      callback(cache, {fromCache: true, cacheIndex: cacheIndex});
    } else {
      $.ajax({
        type: type,
        url: url,
        data: data,
        success: function(data) {
          config.request._cache[cacheIndex] = data;
          callback(data, {fromCache: false, cacheIndex: cacheIndex});
        },
        dataType: dataType,
        cache: false
      });
    }
  },

  post: function(url, dataOrCallback, callback, dataType) {
    this._request("POST", url, dataOrCallback, function(data, cached){
      callback(data, cached);
    }, dataType);
  },

  get: function(url, dataOrCallback, callback, dataType) {
    this._request("GET", url, dataOrCallback, function(data, cached){
      callback(data, cached);
    }, dataType);
  },

  load: function(element, url, dataOrCallback, callback, dataType, type) {
    type = type || "GET";
    _e(element).ready(function($element){
      config.request._request(type, url, dataOrCallback, function(data, cached){
        $element.html(data);
        callback(data, cached);
      }, dataType);
    }, 300);
  },
};

/* -----------------------------------------------------------------
  CONFIG ELEMENT
----------------------------------------------------------------- */
config.element = {
  _instances:  {},

  _instance: function(selector) {
    var self = this;
    this.sliding = false;

    if (selector instanceof jQuery) {
      this.selector = selector;
    } else {
      this.selector = $(selector);
    }

    this.ready = function(callback, timeout) {
      $(function(){
        var interval;
        var loop = 0;
        interval = setInterval(function(){
          ++loop;
          if (self.selector.length || (timeout && loop == timeout)) {
            if (self.selector.length) {
              callback(self.selector);
            }
            clearInterval(interval);
          }
        }, 50);
      });
    }

    this.load = function(url, dataOrCallback, callback, dataType, type) {
      config.request.load(self.selector, url, dataOrCallback, function(data, cached){
        callback(data, cached);
      }, dataType, type);
    }

    this.toggleText = function(object){
      self.ready(function($element){
        $element.text(object.onCondition ? object[1] : object[0]);
      });
    }

    this.centerScreenOn = function(scrollSpeed){
      scrollSpeed = scrollSpeed || 200;
      self.ready(function($element){
        $('html, body').animate({
          scrollTop: $element.offset().top - $(window).height()/2 + $element.outerHeight()/2
        }, scrollSpeed);
      });
    }

    this.slideFadeDown = function(speed, callback) {
      speed = speed || 200;
      self.ready(function($element){
        if (!$element.is(':visible')) {
          $element
            .css('opacity', 0)
            .slideDown(speed)
            .animate({ opacity: 1 }, {
              queue: false,
              duration: speed,
              complete: callback
            });
        }
      });
    }

    this.slideFadeUp = function(speed, callback) {
      speed = speed || 200;
      self.ready(function($element){
        if ($element.is(':visible')) {
          $element
            .css('opacity', 1)
            .slideUp(speed)
            .animate({ opacity: 0 }, {
              queue: false,
              duration: speed,
              complete: callback
            });
          }
      });
    }

    this.slideFadeToggle = function(speed, callback) {
      self.ready(function($element){
        if (!self.sliding) {
          self.sliding = true;
          if ($element.is(':visible')) {
            self.slideFadeUp(speed, function(){
              self.sliding = false;
              if (callback) {
                callback();
              }
            });
          } else {
            self.slideFadeDown(speed, function(){
              self.sliding = false;
              if (callback) {
                callback();
              }
            });
          }
        }
      });
    }
  }
}

/* -----------------------------------------------------------------
  CONFIG LOCATION OBJECT
----------------------------------------------------------------- */
config.location = {
  current: window.location.pathname.substr(1) ? window.location.pathname.substr(1).replace(/\/$/, '') : 'index',
  root: window.location.pathname.split('/')[1],
  queryString: window.location.search,

  isRoot: function(root) {
    return root.replace(/(\/$|^\/)/g, '') === this.root;
  },

  isPage: function(current) {
    return current.replace(/(\/$|^\/)/g, '') === this.current;
  },

  getQueryString: function(string) {
    if (!window.location.search) {
      return false;
    }

    if (string) {
      var query = this.queryString;
    } else {
      var query = [];
      this.queryString.replace(/(^\?)/, '').split('&').forEach(function(param){
        param = param.split('=');
        query[decodeURIComponent(param[0])] = decodeURIComponent(param[1]);
      });
    }
    return query;
  },

  getParam: function(param) {
    var queries = this.getQueryString();
    param = param.trim();
    return (param && queries && queries[param]) ? queries[param] : false;
  }
};

/* -----------------------------------------------------------------
  CONFIG SCREEN OBJECT
----------------------------------------------------------------- */
config.screen = {
  _resizeCallbacks: [],
  _resize: function() {
    $(window).on('load resize', function(){
      var windowWidth = $(window).width();
      config.screen.size = windowWidth;
      if (config.screen._resizeCallbacks.length) {
        config.screen._resizeCallbacks.forEach(function(callback){
          callback(windowWidth);
        });
      }
    });
  }(),

  /*
    @var size | Int
    Current width of window. Adjusts as browser resizes.
  */
  size: $(window).width(),

  /*
    @method onResize
    @param callback | Function(windowWidth)

    Define a function to perform on window resize.
  */
  onResize: function(callback) {
    config.screen._resizeCallbacks.push(callback);
  },

  /*
    @method atSize
    @param size | Int
    @param callback | Function

    Define a function to perform when the window size is exactly
    the size passed to the first position.
  */
  atSize: function(size, callback) {
    config.screen.onResize(function(windowWidth){
      if (windowWidth === size) {
        callback(windowWidth);
      }
    });
  },

  /*
    @method whenSmallerThan
    @param size | Int
    @param callback | Function

    Define a function to perform ONCE when the window size becomes
    smaller than the size passed to the first position.
  */
  whenSmallerThan: function(size, callback) {
    var callbackFired = false;
    config.screen.onResize(function(windowWidth){
      if (windowWidth < size) {
        if (!callbackFired) {
          callback(windowWidth);
          callbackFired = true;
        }
      } else {
        callbackFired = false;
      }
    });
    return this;
  },

  /*
    @method whileSmallerThan
    @param size | Int
    @param callback | Function

    Define a function to perform while the window size is
    smaller than the size passed to the first position.
  */
  whileSmallerThan: function(size, callback) {
    config.screen.onResize(function(windowWidth){
      if (windowWidth < size) {
        callback(windowWidth);
      }
    });
    return this;
  },

  /*
    @method whenLargerThan
    @param size | Int
    @param callback | Function

    Define a function to perform ONCE when the window size becomes
    larger than the size passed to the first position.
  */
  whenLargerThan: function(size, callback) {
    var callbackFired = false;
    config.screen.onResize(function(windowWidth){
      if (windowWidth > size) {
        if (!callbackFired) {
          callback(windowWidth);
          callbackFired = true;
        }
      } else {
        callbackFired = false;
      }
    });
    return this;
  },

  /*
    @method whileLargerThan
    @param size | Int
    @param callback | Function

    Define a function to perform while the window size is
    larger than the size passed to the first position.
  */
  whileLargerThan: function(size, callback) {
    config.screen.onResize(function(windowWidth){
      if (windowWidth > size) {
        callback(windowWidth);
      }
    });
    return this;
  }
};

/* -----------------------------------------------------------------
  CONFIG EMAIL OBJECT
----------------------------------------------------------------- */
config.email = {
  elements: $('[data-mail-name]'),

  _convert: function($element) {
    $element.attr('href', 'mailto:' + $element.data('mail-name') + '@' + $element.data('mail-host'));
    if ($element.text() === '') {
      $element.text($element.data('mail-name') + '@' + $element.data('mail-host'));
    }
    $element.removeAttr('data-mail-name');
    $element.removeAttr('data-mail-host');
  },

  mailToInject: function(el) {
    if (el) {
      config.email._convert(el);
    } else {
      config.email.elements.each(function(){
        config.email._convert($(this));
      });
    }
  }
}

/* -----------------------------------------------------------------
  MAIL TO INJECT INIT
----------------------------------------------------------------- */
config.email.mailToInject();

(function(){
  var ebrochure = {
    dom: function() {
      this.$ebrochureForm      = $('#ebrochure');
      this.$ebrochureError     = $('#ebrochure-error');
      this.$ebrochureRow       = $('[data-js-hook="ebrochure-row"]');
      this.$ebrochureEmailForm = $('#ebrochure-email');
      this.$ebrochureConfirm   = $('#formConfirm');
      this.$sendAgain          = $('#sendAgain');
      this.$checkbox           = $('[data-js-hook="checkbox"]');
    },

    validateSelection: function() {
      var self = this;
      this.$ebrochureForm.submit(function(e){
        var checked = [];

        self.$checkbox.each(function(){
          if ($(this).prop('checked')) {
            checked.push(1);
          }
        });

        if (checked.length) {
          self.$ebrochureError.hide();
        } else {
          e.preventDefault();
          self.$ebrochureError.show();
        }
      });
    },

    emailForm: function() {
      var self = this;

      if (typeof formulate != 'undefined') {
        this.$ebrochureEmailForm.formulate({
          require: 'brochureEmail{email}',
          ajaxSuccess: 'Success!',
          errorClass: 'ebrochure__input--error',
          inlineMsg: true,
          inlineMsgClass: 'ebrochure__inline-msg',
          hideFormOnSubmit: true,
          showOnSubmit: '.form__confirm',
          ajax: true
        });
      }

      this.$sendAgain.click(function(e) {
        e.preventDefault();
        $('#brochureEmail').val('').focus();
        $('.form__confirm').hide();
        self.$ebrochureEmailForm.show();
      });
    },

    rowSelect: function() {
      this.$checkbox.click(function(e){
        e.stopPropagation();
      });

      this.$ebrochureRow.click(function(e){
        var $checkbox = $('#' + $(this).data('checkbox'));
        if ($checkbox.prop('checked')) {
          $checkbox.prop('checked', false);
        } else {
          $checkbox.prop('checked', true);
        }
      });
    },

    ready: function() {
      this.dom();
      this.validateSelection();
      this.emailForm();
      this.rowSelect();
    }
  };

  $(function(){
    ebrochure.ready();
  });
})();

(function($){
  'use strict';

  var features = {
    dom: function() {
      this.$gallery = $('[data-js-hook="feature-gallery"]');
    },

    gallery: function() {
      this.$gallery.each(function() {
        var $this = $(this);
        var directionNav = $(this).data('gallery-nav') === 'direction' ? true : false;
        var controlNav = $(this).data('gallery-nav') === 'control' ? true : false;
        $(this).flexslider({
          namespace: 'features__item-',
          selector: '.features__item-images > .features__item-image',
          directionNav: directionNav,
          controlNav: controlNav,
          customDirectionNav: $(this).parent().find('.features__item-nav a'),
          start: function(slider) {
            if (typeof slider.controlNav == 'object') {
              var totalCount = slider.controlNav.length;
              totalCount = totalCount.toString().length;
              slider.controlNav.each(function() {
                var text = zeroPad($(this).text(), totalCount);
                $(this).text(text);
              });
            }
          }
        });
      });
    },

    ready: function() {
      this.dom();
      this.gallery();
    }
  };

  $(document).ready(features.ready());

})(jQuery);

(function(){
  var floorplan = {
    dom: function() {
      this.$floorplanFilter = $('#floorplan-filter-form');

      this.$bedroomFilterInput = $('#bedroom-filter-input');
      this.$bedroomCheckbox = $('[data-js-hook="bedroom-checkbox"]');
      this.$bedroomFilter = $('[data-js-hook="bedroom-filter"]');
      this.$bedroomClear = $('#bedroom-clear');

      this.$floorplanFilterSelect = $('[data-js-hook="floorplan-filter-select"]');
      this.$resetFilters = $('#reset-filters');

      this.$availableUnits = $('#available-units');
      this.$availableUnitsText = $('#available-units-text');
      this.$availableCheckbox = $('#available');

      this.$expandFilters = $('#expand-filters');
      this.$filters = $('#filters');
      this.$expandAdvancedFilters = $('#expand-advanced-filters');
      this.$advancedFilters = $('#advanced-filters');

      this.$floorplans = $('[data-js-hook="floorplan"]');
      this.$filterResults = $('#filter-results');
      this.$filterResultsCount = $('#filter-results-count');
      this.$noResultMessage = $('#no-result-message');

      this.$launchEmbed  = $('#launch-embed');
      this.$embedFrame = $('#embed-frame');
      this.$mobileEmbed = $('#mobile-embed');
      this.$viewToggle = $('[data-toggle-view]');
      this.$view = $('[data-view]');
    },

    data: {
      floorplanData: typeof preload !== 'undefined' ? preload.floorplans : false,
      activeBedroomLinkClass: 'floorplan-filter__bed-link--active',
      activeAvailableNowClass: 'floorplan-filter__button--active',
      activeFilterResultsClass: 'floorplan-filter__results--active'
    },

    validateFloorplan: function(floorplanDetails, criteria) {
      if (floorplanDetails.bedroom && criteria.bedroom && criteria.bedroom.length && criteria.bedroom.indexOf(floorplanDetails.bedroom) <= -1) {
        return false;
      }

      if ((criteria.min_rent && !floorplanDetails.min_rent) || (criteria.max_rent && !floorplanDetails.max_rent)) {
        return false;
      }

      // -- Min Rent validation.
      if (floorplanDetails.max_rent && !criteria.max_rent && criteria.min_rent && floorplanDetails.max_rent < criteria.min_rent) {
        return false;
      }

      // -- Max Rent validation.
      if (floorplanDetails.min_rent && !criteria.min_rent && criteria.max_rent && floorplanDetails.min_rent > criteria.max_rent) {
        return false;
      }

      // -- Min & Max Rent validation.
      if (floorplanDetails.min_rent && floorplanDetails.max_rent && criteria.min_rent && criteria.max_rent && (floorplanDetails.min_rent > criteria.max_rent || floorplanDetails.max_rent < criteria.min_rent)) {
        return false;
      }

      // -- Square Feet Range validation (hide non-matching item).
      if (floorplanDetails.square_feet) {
        if (criteria.min_square_feet && criteria.max_square_feet) {
          if (floorplanDetails.max_square_feet) {
            if (floorplanDetails.max_square_feet < criteria.max_square_feet && floorplanDetails.square_feet > criteria.max_square_feet) {
              return false;
            }
          }
          else {
            if (floorplanDetails.square_feet < criteria.min_square_feet || floorplanDetails.square_feet > criteria.max_square_feet) {
              return false;
            }
          }
        }
        // -- Min Sq. Ft.
        else if (criteria.min_square_feet) {
          if (floorplanDetails.max_square_feet) {
            if (floorplanDetails.max_square_feet < criteria.min_square_feet) {
              return false;
            }
          }
          else {
            if (floorplanDetails.square_feet < criteria.min_square_feet) {
              return false;
            }
          }
        }
        // -- Max Sq. Ft.
        else if (criteria.max_square_feet) {
          if (floorplanDetails.max_square_feet) {
            if (floorplanDetails.max_square_feet < criteria.max_square_feet) {
              return false;
            }
          }
          else {
            if (floorplanDetails.square_feet > criteria.max_square_feet) {
              return false;
            }
          }
        }
      }

      if (criteria.availability) {
        if (!floorplanDetails.availability || !floorplanDetails.availability.length) {
          hasUnitAvailableNow = false;
        } else {
          var now = new Date().getTime();
          var hasUnitAvailableNow = floorplanDetails.availability.some(function(availability){
            return new Date(availability).getTime() <= now;
          });
        }

        return hasUnitAvailableNow;
      }

      return true;
    },

    toggleFloorplanVisibility: function(floorplanIds) {
      var self = this;
      this.$floorplans.hide();
      this.$filterResults.slideDown(100).addClass(self.data.activeFilterResultsClass);
      this.$filterResultsCount.text(floorplanIds.length);

      setTimeout(function(){
        self.$filterResults.removeClass(self.data.activeFilterResultsClass);
      }, 300);

      if (floorplanIds.length) {
        this.$noResultMessage.hide();
        floorplanIds.forEach(function(id){
          self.$floorplans.filter('[data-floorplan="' + id + '"]').show();
        });

        setTimeout(function(){
          self.$floorplans.filter(':visible').css({
            'visibility': 'visible'
          }).addClass('disable-animation');
        }, 10);
      } else {
        this.$noResultMessage.show();
      }
    },

    filter: function() {
      var self = this;
      var loadingTimeout;

      this.$expandAdvancedFilters.click(function(e){
        e.preventDefault();
        var $this = $(this);

        self.$advancedFilters.slideToggle(100, function(){
          $this.text(self.$advancedFilters.is(':visible') ? 'Hide Advanced Filters': 'Show Advanced Filters');
        });
      });

      this.$expandFilters.click(function(e){
        e.preventDefault();
        var $this = $(this);
        self.$filters.slideToggle(200, function(){
          $this.text(self.$filters.is(':visible') ? 'Collapse Filters -' : 'Expand Filters +');
        });
      });

      this.$resetFilters.click(function(e){
        e.preventDefault();
        self.$floorplanFilterSelect.val('');
        self.$availableCheckbox.prop('checked', false).trigger('change');
        self.$bedroomFilter.filter('[data-clear-bedroom]').trigger('click');
      });

      this.$availableUnits.click(function(e){
        e.preventDefault();
        self.$availableCheckbox.prop('checked', !self.$availableCheckbox.prop('checked')).trigger('change');
        self.$floorplanFilter.submit();
      });

      this.$availableCheckbox.change(function(){
        if (self.$availableCheckbox.prop('checked')) {
          self.$availableUnits.addClass(self.data.activeAvailableNowClass);
          self.$availableUnitsText.text('Show All Availability');
        } else {
          self.$availableUnits.removeClass(self.data.activeAvailableNowClass);
          self.$availableUnitsText.text('Show Available Now');
        }
      });

      this.$floorplanFilterSelect.change(function(e){
        self.$floorplanFilter.submit();
      });

      $(window).on('load', function(){
        if (window.location.href.indexOf('?bed=') > -1) {
          self.$floorplanFilter.submit();
          $('html, body').animate({
            scrollTop: $('#pageContent').offset().top
          })
        }
      });

      this.$bedroomFilter.click(function(e){
        e.preventDefault();
        var allUnchecked = true;

        if ($(this).attr('data-clear-bedroom')) {
          self.$bedroomCheckbox.prop('checked', false);
          self.$bedroomFilter.removeClass(self.data.activeBedroomLinkClass);
          $(this).addClass(self.data.activeBedroomLinkClass);
        } else {
          var $checkbox = $(this).next().filter(self.$bedroomCheckbox);

          $checkbox.prop('checked', !$checkbox.prop('checked'));
          $(this).toggleClass(self.data.activeBedroomLinkClass);
          self.$bedroomFilter.filter('[data-clear-bedroom]').removeClass(self.data.activeBedroomLinkClass);
        }

        self.$bedroomCheckbox.each(function(){
          if ($(this).prop('checked')) {
            allUnchecked = false;
          }
        });

        if (allUnchecked) {
          self.$bedroomFilter.filter('[data-clear-bedroom]').addClass(self.data.activeBedroomLinkClass);
        }

        self.$floorplanFilter.submit();
      });

      this.$floorplanFilter.submit(function(e){
        e.preventDefault();
        var dataObject = {};
        var matchedResults = [];

        $(this).serializeArray().forEach(function(data){
          if (data.name.match(/\[\]$/)) {
            var prop = data.name.replace(/\[\]$/, '');

            if (!dataObject[prop]) {
              dataObject[prop] = [];
            }

            dataObject[prop].push(data.value);
          } else {
            dataObject[data.name] = data.value;
          }
        });

        for (id in self.data.floorplanData) {
          var floorplan = self.data.floorplanData[id];
          if (self.validateFloorplan(floorplan, dataObject)) {
            matchedResults.push(floorplan.id);
          }
        }

        self.toggleFloorplanVisibility(matchedResults);
      });
    },

    views: function() {
      var self = this;

      this.$launchEmbed.click(function(e){
        e.preventDefault();
        self.$embedFrame.show();
      });

      this.$embedFrame.click(function(e){
        $(this).hide();
      });

      this.$viewToggle.click(function(e){
        e.preventDefault();
        var view = $(this).data('toggle-view');

        self.$viewToggle.removeClass('floorplan-toggle__tab--active');

        $(this).addClass('floorplan-toggle__tab--active');

        self.$view.hide();
        self.$view.filter('[data-view="' + view + '"]').show();
      });


      if (this.$mobileEmbed.length) {
        this.$mobileEmbed.magnificPopup({
          type: 'iframe',
          mainClass: 'interactive-embed',
          closeMarkup: '<button title="%title%" type="button" class="mfp-close">Back to Site</button>'
        });
      }
    },

    ready: function() {
      this.dom();
      this.filter();
      this.views();
    }
  }

  $(function(){
    floorplan.ready();
  });
})();

(function($) {

  var floorplan = {
    dom: function() {
      this.$table               = $('[data-js-hook="panel"]').filter('[data-type="check-availability"]');
      this.$floorSelect         = $('#floor-select');
      this.$floorToggle         = $('[data-js-hook="floor-toggle"]');
      this.$dimensionToggle     = $('[data-js-hook="dimension-toggle"]');
      this.$floorplanImage      = $('[data-js-hook="floorplan-image"]');
      this.$dimensionWrap       = $('[data-js-hook="dimension-wrap"]');
      this.$toggleDimensionWrap = $('#toggle-dimension-wrap');
      this.$togglePanel         = $('[data-js-hook="toggle-fp-panel"]');
      this.$panel               = $('[data-js-hook="panel"]');
      this.$toggleLeaseTerm     = $('[data-js-hook="expand-lease-term"]');
      this.$toggleAmenities     = $('[data-js-hook="expand-amenities"]');
      this.$leaseTerm           = $('[data-js-hook="lease-term"]');
      this.$amenities           = $('[data-js-hook="amenities"]');
      this.$toggleWalkthrough   = $('[data-toggle-walkthrough]');
      this.$walkthrough         = $('[data-walkthrough]');
      this.$leaseTermNow        = $('[data-js-hook="lease-now"]').filter('[data-lease-term="true"]');
    },

    data: {
      activeToggleClass : 'floorplan-details__toggle-link--active',
      activeButtonClass : 'floorplan-details__button--active'
    },

    floorToggle: function() {
      var self = this;

      this.$floorToggle.click(function(e){
        e.preventDefault();
        self.$floorToggle.removeClass(self.data.activeToggleClass);
        $(this).addClass(self.data.activeToggleClass);
        self.$floorplanImage.hide().filter('[data-dimension="' + $(this).data('dimension') + '"]').filter('[data-floor="' + $(this).data('floor') + '"]').show();
      });

      this.$floorSelect.click(function(e){
        e.preventDefault();
        $(this).next().slideToggle(100);
      });
    },

    dimensionToggle: function() {
      var self = this;

      this.$dimensionToggle.click(function(e){
        e.preventDefault();
        var dimension = $(this).data('dimension');
        self.$dimensionToggle.removeClass(self.data.activeToggleClass);
        $(this).addClass(self.data.activeToggleClass);
        self.$dimensionWrap.hide().filter('[data-dimension="' + dimension + '"]').show();
        self.$floorToggle.filter('[data-dimension="' + dimension + '"]').first().trigger('click');
      });
    },

    togglePanel: function() {
      var self = this;

      this.$togglePanel.click(function(e) {
        e.preventDefault();
        var $panel = self.$panel.filter('[data-type="' + $(this).data('panel') + '"]');
        self.$togglePanel.removeClass(self.data.activeButtonClass);
        $(this).addClass(self.data.activeButtonClass);

        self.$panel.slideUp(200);

        if (!$panel.is(':visible')) {
          $panel.slideDown(200, function(){
            $('html, body').animate({scrollTop: $panel.outerHeight() > $(window).height() ? $panel.offset().top - 20 : ($panel.offset().top - $(window).height()/2 + $panel.outerHeight()/2)});
          });
        } else {
          $(this).removeClass(self.data.activeButtonClass);
        }
      });
    },

    toggleLeaseTerm: function() {
      var self = this;

      this.$toggleLeaseTerm.click(function(e){
        e.preventDefault();
        self.$amenities.filter('[data-unit="' + $(this).data('unit') + '"]').hide();
        self.$leaseTerm.filter('[data-unit="' + $(this).data('unit') + '"]').toggle();
      });
    },

    toggleAmenities: function() {
      var self = this;

      this.$toggleAmenities.click(function(e){
        e.preventDefault();
        self.$leaseTerm.filter('[data-unit="' + $(this).data('unit') + '"]').hide();
        self.$amenities.filter('[data-unit="' + $(this).data('unit') + '"]').toggle();
      });
    },

    toggleWalkthrough: function() {
      var self = this;

      this.$toggleWalkthrough.click(function(e){
        e.preventDefault();
        var $this = $(this);
        var $walkthrough = self.$walkthrough.filter('[data-walkthrough=' + $this.data('toggle-walkthrough') + ']');
        var $altToggle = self.$toggleWalkthrough.filter('[data-toggle-walkthrough=' + ($this.data('toggle-walkthrough') == 1 ? 2 : 1) + ']');

        if ($altToggle.data('open')) {
          $altToggle.trigger('click');
        }

        if ($this.data('open')) {
          $walkthrough.hide();
          $this.removeClass('floorplan-details__toggle-link--active floorplan-details__toggle-link--active-walkthrough').find('span').remove();
          $this.data('open', 0);
          self.$toggleDimensionWrap.show();
        } else {

          if (!$walkthrough.attr('src')) {
            $walkthrough.attr('src', $walkthrough.data('src'));
          }

          $walkthrough.show();
          $this.addClass('floorplan-details__toggle-link--active floorplan-details__toggle-link--active-walkthrough').append('<span>&times;</span>');
          $this.data('open', 1);

          self.$toggleDimensionWrap.hide();
        }


      });
    },

    leaseTerm: function () {
      if (!parseInt(this.$table.data('skip-step-init'))) {
        this.$leaseTermNow.click(function(){
          $(this).attr('href').replace('{lease_term}', $('[data-js-hook="lease-term-input"]').filter('[data-unit="' + $(this).data('unit') + '"]:checked').val());
        });
      }
    },

    ready: function() {
      this.dom();
      this.floorToggle();
      this.dimensionToggle();
      this.togglePanel();
      this.toggleLeaseTerm();
      this.toggleAmenities();
      this.toggleWalkthrough();
      this.leaseTerm();
    }
  };

  $(function(){
    floorplan.ready();
  });

})(jQuery);

(function(){

  var gallery = {
    dom: function() {
      this.$tab = $('[data-js-hook="tab"]');
      this.$container = $('#gallery-container');
      this.$loading = $('#loading');
      this.$openCategories = $('[data-js-hook="open-categories"]');
      this.$tabWrap = $('#tab-wrap');
    },

    data: function() {
      this.layout = this.$container.data('layout');
    },

    tab: function() {
      var self = this;

      this.$tab.click(function(e){
        e.preventDefault();
        var $this = $(this);
        var showLoader = setTimeout(function(){
          self.$loading.fadeIn(200);
        }, 500);

        self.$container.load('/gallery/', {category: $(this).data('category'), layout: self.layout}, function(){
          clearTimeout(showLoader);
          self.$loading.fadeOut(200);
          self.$tab.removeClass('gallery__tab--active');
          $this.addClass('gallery__tab--active');
          self.$openCategories.text($this.text());
          self.swipebox();

          if ($(window).width() <= 808) {
            self.$tabWrap.slideUp(100);
          }

          if (self.layout === 2) {
            self.rotator();
            self.layoutToggle();
          }

          $('[data-src]').lazyload();
        });
      });

      this.$openCategories.click(function(e){
        e.preventDefault();
        self.$tabWrap.slideToggle(100);
      });
    },

    rotator: function() {
      var self = this;

      $('#pager').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 218,
        itemMargin: 20,
        asNavFor: '#gallery-rotator'
      });

      $('#gallery-rotator').flexslider({
        animation: "slide",
        controlNav: false,
        directionNav: false,
        animationLoop: false,
        slideshow: false,
        sync: "#pager",
        before: function() {
          $('#swipe').fadeOut(80);
        }
      });
    },

    layoutToggle: function() {
      var self = this;

      if ($('[data-js-hook="layout-toggle"]').length) {
        $('[data-js-hook="layout-toggle"]').click(function(e){
          e.preventDefault();
          $('[data-js-hook="layout-toggle"]').removeClass('gallery-b__layout-toggle-button--active');
          $(this).addClass('gallery-b__layout-toggle-button--active');
          $('[data-js-hook="layout"]').hide();
          $('[data-js-hook="layout"]').filter('[data-layout="' + $(this).data('layout') + '"]').show();
        });
      }
    },

    swipebox: function() {
      if ($('[data-js-hook="gallery-swipebox"]').length) {
        $('[data-js-hook="gallery-swipebox"]').unbind().swipebox({
          hideBarsDelay: false,
          removeBarsOnMobile: false,
          loopAtEnd: true,
          afterOpen: function(){
            // -- Trigger close event on #swipebox-container click event.
            $('#swipebox-container').click(function(e){
              e.preventDefault();
              $('#swipebox-close').trigger('click');
            });
            // -- Wait for image to load after open, then bind click events
            // -- to disable propogation from certain elements.
            var interval;
            interval = setInterval(function(){
              if ($('#swipebox-slider .slide.current img').length) {
                clearInterval(interval);
                $('#swipebox-top-bar, #swipebox-slider .slide.current img').click(function(e){
                  e.stopPropagation();
                });
              }
            }, 200);
          }
        });
      }
    },

    ready: function() {
      this.dom();
      this.data();
      this.tab();
      this.swipebox();
      if (this.layout === 2) {
        this.rotator();
        this.layoutToggle();
      }
    }
  }

  $(function(){
    gallery.ready();
  });
})();

function cmg_google_conversion(sDoGoogleConversion, iConversionId, sImageHtml) {
  //set this to FALSE to skip all of the code in this function (instead of deleting the actual code sample)
  var bDoGoogleConversion = false;
  if (sDoGoogleConversion == 'On') { bDoGoogleConversion = true; }

  if (bDoGoogleConversion) {
    var google_conversion_id = iConversionId;
    var google_custom_params = window.google_tag_params;
    var google_remarketing_only = true;

    //inject the 1 pixel image onto the page, thus calling the Google tracking
    $('body').append(sImageHtml);
  }

  return true;
}

(function(){

  var index = {
    dom: function() {
      this.$rotator       = $('#rotator');
      this.$rotatorScroll = $('#rotator-scroll');
      this.$stickyHeader  = $('#sticky-header');
      this.$video         = $('#homeVideo');
      this.$map           = $('#homeMap');
      this.$gallery       = $('[data-js-hook="homeGallery"]');
      this.$footer        = $('#footer');
    },

    rotator: function() {
      var main = this;

      if (typeof rotatorSettings !== 'undefined') {
        this.$rotator.flexslider({
          controlNav      : true,
          directionNav    : true,
          slideshowSpeed  : rotatorSettings.speed,
          start           : function(slider) {
            if (slider.count < 2) {
              slider.controlNavScaffold.remove();
              $(slider.directionNav[0]).closest('ul').remove();
            }
            if (rotatorSettings.ken_burns) {
              slider.slides.eq(slider.currentSlide).addClass('animate-slide');
            }
          },
          before          : function(slider) {
            if (rotatorSettings.ken_burns) {
              slider.slides.eq(slider.animatingTo).addClass('animate-slide');
            }
          },
          after           : function(slider) {
            var prevSlide = slider.currentSlide === 0 ? slider.last : slider.currentSlide - 1;
            if (rotatorSettings.ken_burns) {
              slider.slides.eq(prevSlide).removeClass('animate-slide');
            }
          }
        });

        if (rotatorSettings.stretch) {
          var self = this;

          $(window).on('load resize', function(){
            self.$rotator.height($(window).height() - self.$rotator.offset().top);
          });
        }
      }
    },

    rotatorScroll: function() {
      var self = this;

      this.$rotatorScroll.click(function(e){
        e.preventDefault();
        $('html, body').animate({
          scrollTop: self.$stickyHeader.length ? self.$rotator.outerHeight() - self.$stickyHeader.outerHeight() : self.$rotator.height()
        });
      });
    },

    video: function() {
      Modernizr.on('videoautoplay', function(result) {
        if (!result && $('#homeVideo').length) {
          if ('playsInline' in document.createElement('homeVideo')) {
            return false;
          }
          else {
            var video = document.getElementById('homeVideo');
            if (video.play() === undefined) {
              video.remove();
              $('.homepage__video-fallback').show();
            }
          }
        }
      });
    },

    gallery: function() {
      var offset = 0;
      var self = this;

      $(window).on('load resize', function() {
        offset = self.$footer.offset().left;
        self.$gallery.css('margin-right', offset);
      });
    },

    map: function() {
      var offset = 0;
      var self = this;

      $(window).on('load resize', function() {
        offset = self.$footer.offset().left;
        self.$map.css('margin-left', offset);
      });
    },

    ready: function() {
      this.dom();
      this.rotator();
      this.rotatorScroll();
      this.video();
      this.gallery();
      this.map();
    }
  }

  $(function(){
    index.ready();
  });

})();

function zeroPad(num, size) {
  var s = num+"";
  length = size == 1 ? 2 : size;
  while (s.length < length) s = "0" + s;
  return s;
}

var recaptchas = function() {
  $(function(){
    $('[data-recaptcha]').each(function(){
      var $this = $(this);

      grecaptcha.render($(this).get(0), {
        sitekey: $(this).data('sitekey'),
        callback: function(response) {
          if (response) {
            $this.parents('form').submit();
            $this.after('<input type="submit" class="form__field form__field--submit" value="' + ($this.data('recaptcha') == 'tour_form' ? 'Submit' : 'Send') + '" />').remove();
          }
        }
      });
    });
  });
};

(function($) {
  'use strict';

  var init = {
    dom: function() {
      this.petPolicy = {
        $button : $('#pet-policy'),
        $flyout : $('#pet-policy-flyout')
      };

      this.popupEls = {
        $container : $('#popup'),
        $overlay   : $('#popup-overlay'),
        $close     : $('#popup-close'),
        $modal     : $('#popup-modal')
      };

      this.$swipebox      = $('[data-js-hook="swipebox"]');
      this.$swipeboxVideo = $('[data-js-hook="swipebox-video"]');
      this.$datePicker    = $('[data-js-hook="pickadate"]');
      this.$infieldLabels = $('[data-infield-label]');
      this.$formLoader    = $('#form-loading');
      this.$contactForm   = $('#contact-form');
      this.$tourForm      = $('#schedule-a-tour-form');
      this.$header        = $('#header');
      this.$stickyHeader  = $('#sticky-header');
      this.$email         = $('[data-mail-name]');
      this.$lazyImage     = $('[data-src]');
      this.$pageBanner    = $('#pageBanner');
      this.$scrollDown    = $('[data-js-hook="scrollDown"]');
      this.$rotator       = $('[data-rotator]');
      this.$parallax      = '[data-parallax]';
      this.$parallaxBG    = $('[data-js-hook="parallax-bg"]');

      this.$popdown      = $('#popdown');
      this.fixedElements = $('[data-fixed]');
    },

    lazyLoad: function() {
      this.$lazyImage.lazyload();
    },

    stickyHeader: function() {
      var main = this;

      $(window).on('scroll load', function(){
        if ($(window).scrollTop() > 1) {
          $('body').addClass('stuck');
        }
        else {
          $('body').removeClass('stuck');
        }
      });
    },

    infieldLabels: function() {
      this.$infieldLabels.each(function() {
        var $this = $(this);
        var target = $(this).attr('for');
        var input = $('#'+target);
        input.on('focus', function(){
          if (!$(this).val()) {
            $this.addClass('focus');
          }
        });
        input.on('keyup input', function() {
          if ($(this).val()) {
            $this.removeClass('focus');
            $this.addClass('active');
          }
          else {
            $this.removeClass('active');
            $this.addClass('focus');
          }
        });
        input.on('blur', function() {
          if (!$(this).val()) {
            $this.removeClass('focus');
          }
        });
      });
    },

    pickadate: function() {
      if (this.$datePicker.length) {
        this.$datePicker.pickadate({
          onSet: function(thingSet) {
            var label = $(this)[0].$node.attr('id');
            label = $('[for='+label+']');
            if (thingSet.select !== undefined) {
              label.addClass('active');
            }
            else {
              label.removeClass('active');
            }
          }
        });
      }
    },

    execPetPolicy: function() {
      var main = this;
      var policyCloserTimeout;

      this.petPolicy.$flyout.mouseenter(function(){
        clearTimeout(policyCloserTimeout);
      }).mouseleave(function(){
        main.petPolicy.$button.removeClass('header__toolbar-content--active-pet');
        main.petPolicy.$flyout.fadeOut(100);
      });

      this.petPolicy.$button.click(function(e){
        e.preventDefault();
        $(this).addClass('header__toolbar-content--active-pet');
        main.petPolicy.$flyout.fadeToggle(100);
      }).mouseleave(function(e){
        var $this  = $(this);

        policyCloserTimeout = setTimeout(function(){
          $this.removeClass('header__toolbar-content--active-pet');
          main.petPolicy.$flyout.fadeOut(100);
        }, 30);
      });
    },

    swipebox: function() {
      if (this.$swipebox.length) {
        this.$swipebox.swipebox({
          hideBarsDelay: false,
          removeBarsOnMobile: false,
          loopAtEnd: true,
          afterOpen: function(){
            // -- Trigger close event on #swipebox-container click event.
            $('#swipebox-container').click(function(e){
              e.preventDefault();
              $('#swipebox-close').trigger('click');
            });
            // -- Wait for image to load after open, then bind click events
            // -- to disable propogation from certain elements.
            var interval;
            interval = setInterval(function(){
              if ($('#swipebox-slider .slide.current img').length) {
                clearInterval(interval);
                $('#swipebox-top-bar, #swipebox-slider .slide.current img').click(function(e){
                  e.stopPropagation();
                });
              }
            }, 200);
          }
        });
      }
    },

    popup: function() {
      var main = this;
      if (this.popupEls.$container.length) {

        // -- Ensures popup height value is always an even number
        // -- to assist the browsers in not rendering it blurry.
        // -- (Bug with CSS absolute centering)
        if (this.popupEls.$modal.length) {
          $(window).on('load resize', function(){
            main.popupEls.$modal.css('height', 'auto');
            var modalHeight = main.popupEls.$modal.height();
            if (modalHeight % 2 !== 0) {
              main.popupEls.$modal.height(modalHeight + 1);
            }
          });
        }

        // -- Close Click
        this.popupEls.$close.click(function(e){
          e.preventDefault();
          main.popupEls.$container.fadeOut(200);
        });

        // -- Overlay Click
        this.popupEls.$overlay.click(function(){
          main.popupEls.$container.fadeOut(200);
        });
      }
    },

    rotator: function() {
      this.$rotator.each(function() {
        var $this = $(this);
        $(this).flexslider({
          namespace: 'rotator__',
          selector: '.rotator__slides > .rotator__slide',
          directionNav: true,
          controlNav: true,
          start: function(slider) {
            if (typeof slider.controlNav == 'object') {
              var totalCount = slider.controlNav.length;
              totalCount = totalCount.toString().length;
              slider.controlNav.each(function() {
                var text = zeroPad($(this).text(), totalCount);
                $(this).text(text);
              });
            }
            if (slider.count < 2) {
              slider.controlNavScaffold.remove();
              $(slider.directionNav[0]).closest('ul').remove();
            }
          }
        });
      });
    },

    forms: function() {
      var main = this;

      // -- Validate the form
      this.$contactForm.formulate({
        require: 'Name, Email{email}, Message',
        errorClass: 'error',
        errorParent: true,
        showOnSubmit: '#contact-confirm',
        inlineMsg: true,
        inlineMsgClass: 'form__inline-error',
        fireOnSubmit: function() {
          $('.form__loading', main.$contactForm).fadeIn(200);
        },
        fireOnSuccess: function() {
          $('.form__loading', main.$contactForm).fadeOut(200);
          cmg_google_conversion($('#contact_us_conversion').val(), $('#contact_us_conversion_id').val(), $('#contact_us_conversion_html').val());
        },
        fireOnError: function(){
          $('.form__loading', main.$contactForm).fadeOut(200);
          $(document).find('.form__form-field--error').siblings('[data-infield-label]').addClass('form__label--error');
        }
      });

      // -- Validate the form
      this.$tourForm.formulate({
        require: 'FirstName, LastName, Email{email}, Phone',
        errorClass: 'error',
        errorParent: true,
        showOnSubmit: '#schedule-a-tour-confirm',
        inlineMsg: true,
        inlineMsgClass: 'form__inline-error',
        fireOnSubmit: function() {
          $('.form__loading', main.$tourForm).fadeIn(200);
        },
        fireOnSuccess: function() {
          $('.form__loading', main.$tourForm).fadeOut(200);
          cmg_google_conversion($('#schedule_tour_conversion').val(), $('#schedule_tour_conversion_id').val(), $('#schedule_tour_conversion_html').val());
        },
        fireOnError: function(){
          $('.form__loading', main.$tourForm).fadeOut(200);
          $(document).find('.form__form-field--error').siblings('[data-infield-label]').addClass('form__label--error');
        }
      });
    },

    banner: function() {
      var main = this;
      $(window).on('load resize', function() {
        main.$pageBanner.height($(window).height());
      });

      if ($('.page-banner__slide', main.$pageBanner).length > 1) {
        main.$pageBanner.flexslider({
          selector      : '.page-banner__slides > div',
          directionNav  : false,
          controlNav    : false,
          start         : function(slider) {
                            slider.slides.eq(slider.currentSlide).addClass('animate-slide');
                          },
          before        : function(slider) {
                            slider.slides.eq(slider.animatingTo).addClass('animate-slide');
                          },
          after         : function(slider) {
                            var prevSlide = slider.currentSlide === 0 ? slider.last : slider.currentSlide - 1;
                            slider.slides.eq(prevSlide).removeClass('animate-slide');
                          }
        });
      }
    },

    smoothScroll: function() {
      // Select all links with hashes
      $('a[href*="#"]').not('[href="#"]').click(function(event) {
        // On-page links
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          if (!target.length) {
            target = target.length ? target : $('[id=' + this.hash.slice(1) + ']');
          }
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000);
          }
        }
      });
    },

    parallax: function() {
      var main = this;

      $(window).on('load', function() {
        if ($(main.$parallax).length && $(window).width() > breakpoints.fluid) {
          setTimeout(function() {
            var rellax = new Rellax(main.$parallax, {
              speed: -2,
              center: true,
              wrapper: null,
              round: true,
              vertical: true,
              horizontal: false
            });
          }, 500);
        }
      });

      this.$parallaxBG.parallax({
        parallax: 'scroll',
        position: 'top',
        bleed: '0',
        naturalWidth: '1920',
        naturalHeight: '1133'
      });
    },

    popdown: function() {
      var main = this;

      var popdownHeaderAdjust = function() {
        var animatedInterval;

        animatedInterval = setInterval(function(){
          if (main.$popdown.is(':visible')) {
            clearInterval(animatedInterval);
            main.fixedElements.each(function() {
              $(this).css('cssText', 'display:'+$(this).css('display')+';position: absolute !important;');
            });
          }
        }, 200);
      }

      $('#popdownToggle').click(function(e){
        $('html, body').animate({scrollTop: 0}, 100, function(){
          popdownHeaderAdjust();
        });
      });

      if (main.$popdown.length) {
        var clearit = false;

        var $button = main.$popdown.find('.popdown__button');

        if ($button.length) {
          $button.html('<span class="vertaligner">'+$button.text()+'</span>');
        }

        popdownHeaderAdjust();

        $(window).on('load scroll', function(){
          var offset = $(window).scrollTop() - main.$popdown.outerHeight();

          if (offset >= 0 || !main.$popdown.is(':visible')) {
            main.fixedElements.css('position', '');
          } else {
            main.fixedElements.each(function() {
              $(this).css('cssText', 'display:'+$(this).css('display')+';position: absolute !important;');
            });
          }
        });
      }
    },

    wow: function() {
      if (typeof WOW == 'function' && siteSettings.useAnimations) {
        var wow = new WOW({
          boxClass: 'wow',
          animateClass: 'animated',
          offset: 100,
          mobile: false,
          live: false
        });
        wow.init();
      }
    },

    ready: function() {
      this.dom();
      this.lazyLoad();
      this.infieldLabels();
      this.pickadate();
      this.execPetPolicy();
      this.swipebox();
      this.forms();
      this.popup();
      this.rotator();
      this.stickyHeader();
      this.banner();
      this.smoothScroll();
      this.parallax();
      this.popdown();
      this.wow();
    }
  };

  $(function(){
    init.ready();
  });

})(jQuery);

(function() {
  'use strict';

  var init = {
    dom: function() {
      this.menuEls = {
        $button: $('[data-js-hook="menu-toggle"]'),
        $menu: $('#menu'),
        $overlay: $('#menuOverlay'),
        $hamburger: $('#hamburger')
      };

      this.navEls = {
        $wrap    : $('#menu'),
        $buttons : $('#menuButtons > a'),
        $items   : $('#menuItems'),
        $link    : $('.js-menu-link'),
        $social  : $('.navigation .header__social-item')
      }
    },

    menu: function() {
      var self = this;
      var sizes = {};
      var iButtons = self.navEls.$buttons.length;
      var iLinks = self.navEls.$link.length;

      $(window).on('load resize', function() {
        if ($(window).width() > breakpoints.fluid) {
          sizes = {
            'active': {
              'left': 'auto',
              'max-height': 1200
            },
            'inactive': {
              'left': 'auto',
              'max-height': 0
            }
          };
        }
        else {
          sizes = {
            'active': {
              'left': 0,
              'max-height': '100%',
            },
            'inactive': {
              'left': '100%',
              'max-height': '100%',
            }
          };
        }
        self.navEls.$wrap.css(sizes.inactive);
        if ($('body').hasClass('menu-open')) {
          self.navEls.$link.css('opacity', 0);
          self.navEls.$buttons.css('opacity', 0);
          $('body').toggleClass('menu-open');
          self.menuEls.$button.toggleClass('active');
        }
      });

      this.menuEls.$button.stop().click(function(e) {
        e.preventDefault();
        // -- If Menu is OPEN
        if (self.menuEls.$button.hasClass('active')) {

          self.navEls.$social.animate({'opacity': 0, 'top': '2em'}, 50);
          self.navEls.$link.animate({'opacity': 0, 'top': '2em'}, 50);
          self.navEls.$buttons.animate({'opacity': 0, 'top': '2em'}, 50);
          self.navEls.$wrap.animate(sizes.inactive, 400);
        }
        // -- If Menu is CLOSED
        else {
          // -- Open Menu
          self.navEls.$wrap.animate(sizes.active, 200, function() {
            // -- Slide up top buttons
            self.navEls.$buttons.each(function(iButton, obj) {
              var link = $(this);
              setTimeout(function() {
                link.animate({
                  'opacity': 1,
                  'top': 0
                }, 400, function() {
                  if (iButton === (iButtons -1)) {
                    // -- Slide up social media
                    self.navEls.$social.each(function(iSocialLink, obj) {
                      var link = $(this);
                      setTimeout(function() {
                        link.animate({
                          'opacity': 1,
                          'top': 0
                        }, 400);
                      }, (iSocialLink * 100));
                    });
                    // -- Slide up links
                    self.navEls.$link.each(function(iLink, obj) {
                      var link = $(this);
                      setTimeout(function() {
                        link.animate({
                          'opacity': 1,
                          'top': 0
                        }, 400);
                      }, (iLink * 100));
                    });
                  }
                });
              }, (iButton === (iButtons -1) ? 0 : (iButton * 100)));
            });
          });
        }
        $('body').toggleClass('menu-open');
        self.menuEls.$button.toggleClass('active');
      });
    },

    ready: function() {
      this.dom();
      this.menu();
    }
  }

  $(function(){
    init.ready();
  });
})(jQuery);

  var indexMap = {
    dom: function() {
      this.$mapCanvas           = $('#index_map_canvas');
      this.$zoomIn              = $('#zoom_in');
      this.$zoomOut             = $('#zoom_out');
      this.$refresh             = $('#refresh');
      this.$mainInfoBoxTemplate = $('#main-infobox-template');
    },

    definitions: function() {
      // -- Probably don't want to touch.
      this.instance;
      this.mainInfoBox;
      this.assetPath = config.siteUrl + mapSettings.assetPath.replace(/^\/|\/$/g, '') + '/';
      this.icons = {};

      // -- You can touch.
      this.zoomIncrement = 1;
      this.homeImageFile = 'map_home.png';
      this.mainInfoboxHTML = this.$mainInfoBoxTemplate.html();
      this.mapStyles = mapStyles
    },

    onGoogleLoad: function(callback){
      var self = this;
      google.load("search", "1.0", {
        callback: callback
      });
    },

    loadMap: function(event, preservePoints) {
      indexMap.setOptions();
      indexMap.googleMap = google.maps;
      indexMap.instance = new indexMap.googleMap.Map(indexMap.$mapCanvas[0], indexMap.mapOptions);
      indexMap.bindControls();
      indexMap.googleMap.event.addDomListener(window, 'resize', indexMap.mapResize);

      // -- Place Home Marker
      var mainMarker = new indexMap.googleMap.Marker({
        map: indexMap.instance,
        position: indexMap.latlng,
        icon : indexMap.assetPath + indexMap.homeImageFile
      });

      // -- Build InfoBox & Bind Toggle Controls
      indexMap.mainInfoBox = $.extend(new InfoBox(indexMap.pinpointOptions), {isMain: true});
      indexMap.openMarker(indexMap.mainInfoBox, mainMarker);
      indexMap.bindMarkerOpen(indexMap.mainInfoBox, mainMarker);
    },

    mapResize: function() {
      var boundry = new indexMap.googleMap.LatLngBounds();
      indexMap.instance.setCenter(indexMap.latlng);
    },

    bindMarkerOpen: function(infoBoxObject, markerObject) {
      var self = this;

      this.googleMap.event.addListener(markerObject, 'click', function(){
        if (typeof neighborhoodSettings != 'undefined' && neighborhoodSettings.layout == 4) {
          var scrollTimeout = self.$indexMap.data('fixed') ? 0 : 600;

          setTimeout(function(){
            self.openWindow.close();
            self.openMarker(infoBoxObject, markerObject);
          }, scrollTimeout);
        } else {
          self.openWindow.close();
          self.openMarker(infoBoxObject, markerObject);
        }
      });
    },

    openMarker: function(infoBoxObject, markerObject, callback) {
      // -- Close all InfoBoxes except Main
      if (this.openWindow && !this.openWindow.isMain) {
        this.openWindow.close();
      }

      // -- Open new InfoBox
      infoBoxObject.open(this.instance, markerObject);
      this.openWindow = infoBoxObject;
    },

    bindControls: function() {
      var self = this;

      // -- Map click closes all windows
      this.googleMap.event.addListener(self.instance, 'click', function(){
        self.mainInfoBox.close();
        if (self.openWindow) {
          self.openWindow.close();
        }
      });

      // -- Zoom In Control
      this.$zoomIn.unbind().click(function(e){
        e.preventDefault();
        self.instance.setZoom(self.instance.getZoom() + self.zoomIncrement);
      });

      // -- Zoom Out Control
      this.$zoomOut.unbind().click(function(e){
        e.preventDefault();
        self.instance.setZoom(self.instance.getZoom() - self.zoomIncrement);
      });

      // -- Refresh Control
      this.$refresh.unbind().click(function(e){
        e.preventDefault();
        self.loadMap();
      });
    },

    setOptions: function(){
      this.latlng = new google.maps.LatLng(mapSettings.lat, mapSettings.lng);

      // -- Pinpoint Infobox Options Object
      this.pinpointOptions = {
        content: this.mainInfoboxHTML,
        disableAutoPan: false,
        maxWidth: 0,
        pixelOffset: new google.maps.Size(-36, -85),
        zIndex: 9999,
        boxStyle: {},
        boxClass: "homepage__map-infobox",
        closeBoxMargin: "-20px 43px 0 0",
        closeBoxURL: "",
        infoBoxClearance: new google.maps.Size(1, 1),
        isHidden: false,
        pane: "floatPane",
        enableEventPropagation: true
      };

      // -- Map Options Object
      this.mapOptions = {
        zoom: 14,
        minZoom: 5,
        maxZoom: 25,
        scrollwheel: false,
        center: this.latlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        disableDefaultUI: true,
        styles: this.mapStyles
      };
    },

    init: function() {
      this.dom();
      this.definitions();
      this.onGoogleLoad(this.loadMap);
    }
  }

  $(function() {
    if ($('#index_map_canvas').length) {
      indexMap.init();
    }
  });

var neighborhoodMap = {
  dom: function() {
    this.$map                 = $('#map');
    this.$stickyHeader        = $('#sticky-header');
    this.$mapCanvas           = $('#map_canvas');
    this.$map                 = $('#map');
    this.$mapBody             = $('#map-body');
    this.$zoomIn              = $('#zoom_in');
    this.$zoomOut             = $('#zoom_out');
    this.$refresh             = $('#refresh');
    this.$poiFilter           = $('[data-js-hook="poi-filter"]');
    this.$mainInfoBoxTemplate = $('#main-infobox-template');
    this.$infoBoxTemplate     = $('#infobox-template');
    this.$poiToggleBox        = $('[data-js-hook="toggle-poi-infobox"]');
    this.$poiCategory         = $('[data-js-hook="poi-category"]');
  },

  definitions: function() {
    // -- Probably don't want to touch.
    this.instance;
    this.mainInfoBox;
    this.poiMarkers    = [];
    this.assetPath     = config.siteUrl + mapSettings.assetPath.replace(/^\/|\/$/g, '') + '/';
    this.icons = {};

    // -- You can touch.
    this.zoomIncrement   = 1;
    this.defaultCategory = mapSettings.defaultCategory;
    this.currentCategory = null;
    this.homeImageFile   = 'map_home.png';
    this.dataEndpoint    = 'neighborhood';
    this.poiIconFormat   = '{{category}}_small';
    this.mainInfoboxHTML = this.$mainInfoBoxTemplate.html();
    this.poiInfoboxHTML  = this.$infoBoxTemplate.html();
    this.mapStyles = mapStyles
  },

  onGoogleLoad: function(callback){
    var self = this;
    google.load("search", "1.0", {
      callback: callback
    });
  },

  loadMap: function(event, preservePoints) {
    neighborhoodMap.setOptions();
    neighborhoodMap.googleMap = google.maps;
    neighborhoodMap.instance = new neighborhoodMap.googleMap.Map(neighborhoodMap.$mapCanvas[0], neighborhoodMap.mapOptions);
    neighborhoodMap.bindControls();
    neighborhoodMap.googleMap.event.addDomListener(window, 'resize', neighborhoodMap.mapResize);

    if (!neighborhoodMap.currentCategory && !mapSettings.loadAll) {
      neighborhoodMap.currentCategory = neighborhoodMap.defaultCategory;
    }

    var homeIcon = {
      path: "M11,5.5A5.5,5.5,0,1,1,5.5,0,5.5,5.5,0,0,1,11,5.5Z",
      fillColor: siteSettings.mainAccent,
      fillOpacity: 1,
      anchor: new neighborhoodMap.googleMap.Point(5,10),
      strokeWeight: 0,
      scale: 1
    }

    // -- Place Home Marker
    var mainMarker = new neighborhoodMap.googleMap.Marker({
      map: neighborhoodMap.instance,
      position: neighborhoodMap.latlng,
      icon : homeIcon
    });

    // -- Build InfoBox & Bind Toggle Controls
    neighborhoodMap.mainInfoBox = $.extend(new InfoBox(neighborhoodMap.pinpointOptions), {isMain: true});
    neighborhoodMap.openMarker(neighborhoodMap.mainInfoBox, mainMarker);
    neighborhoodMap.bindMarkerOpen(neighborhoodMap.mainInfoBox, mainMarker);

    // -- Draw all POIs to map
    mapSettings.pois.forEach(function(point){
      neighborhoodMap.drawPoint(point);
    });

    if (!preservePoints && neighborhoodMap.loadAll) {
      neighborhoodMap.currentCategory = null;
    } else if(!neighborhoodMap.currentCategory) {
      preservePoints = false;
    }

    neighborhoodMap.poiVisibility(neighborhoodMap.currentCategory, event && event.type == 'resize' ? true : false, !preservePoints);
  },

  mapResize: function() {
    var boundry = new neighborhoodMap.googleMap.LatLngBounds();

    neighborhoodMap.poiMarkers.forEach(function(marker){
      if (marker.category == neighborhoodMap.currentCategory || !neighborhoodMap.currentCategory) {
        boundry.extend(marker.position);
      }
    });

    if ($(window).width() >= 660){
      neighborhoodMap.instance.fitBounds(boundry);
      // neighborhoodMap.instance.setZoom(neighborhoodMap.instance.getZoom());
    } else if ($(window).width() < 660) {
      setTimeout(function(){
        var centerBoundry = new neighborhoodMap.googleMap.LatLngBounds().extend(neighborhoodMap.latlng);
        neighborhoodMap.instance.fitBounds(centerBoundry);
        neighborhoodMap.instance.setZoom(neighborhoodSettings.layout == 4 ? neighborhoodMap.instance.getZoom() - 10 : neighborhoodMap.instance.getZoom() - 7);
      }, 100);
    }
  },

  drawPoint: function(point) {
    var poiInfoboxHTML = this.poiInfoboxHTML.replace(/\n/g, '');
    var poiOptions = this.poiOptions;
    var poiIcon = this.assetPath + this.poiIconFormat.replace(/{{category}}/g, point.icon);

    // -- Parse If Statements
    if (ifStatement = /(\{\{if(.*?)\}\}(.*?)\{\{endif\}\})/g.exec(poiInfoboxHTML)) {
      var condition = ifStatement[2].trim();

      if (point[condition]){
        poiInfoboxHTML = poiInfoboxHTML.replace(ifStatement[1], ifStatement[3]);
      } else {
        poiInfoboxHTML = poiInfoboxHTML.replace(ifStatement[1], '');
      }
    }

    // -- Mustache Var Replace
    for (property in point) {
      var expression = new RegExp('({{' + property + '}})', 'g');
      if (poiInfoboxHTML.match(expression)) {
        poiInfoboxHTML = poiInfoboxHTML.replace(expression, point[property]);
      }
    }

    // -- Determine icon file extension. (.png if IE, .svg if not)
    if (navigator.userAgent.indexOf('rv:11') > -1 || navigator.userAgent.indexOf('MSIE') > -1){
      poiIcon += '.png';
    } else if (this.icons[point.category]) {
      poiIcon = this.icons[point.category];
    } else {
      poiIcon += '.svg';
    }

    // -- Draw point onto neighborhoodMap.
    var poiMarker = new this.googleMap.Marker({
      map: neighborhoodMap.instance,
      position: new this.googleMap.LatLng(point.lat, point.lng),
      icon: poiIcon
    });

    // -- Push marker into array & bind
    this.poiMarkers.push($.extend(poiMarker, {
      category: point.category,
      id: point.id
    }));

    this.bindMarkerOpen(new InfoBox($.extend(poiOptions, {content: poiInfoboxHTML})), poiMarker);
  },

  poiVisibility: function(category, centerOnPoints, reset) {
    var self = this;
    var boundry = new this.googleMap.LatLngBounds();

    // -- Close all InfoBoxes except Main
    if (this.openWindow && !this.openWindow.isMain) {
      this.openWindow.close();
    }

    // -- Hide everything not matching passed-in category
    this.poiMarkers.forEach(function(marker){
      if ((reset && !mapSettings.loadAll) || !reset) {
        marker.setVisible(false);
      }

      if ((marker.category == category) || (reset && mapSettings.loadAll) || category == 'all') {
        boundry.extend(marker.position);
        marker.setVisible(true);
      }
    });

    if ((centerOnPoints && $(window).width() >= 660) || neighborhoodSettings.layout == 4){
      this.instance.fitBounds(boundry);
      this.instance.setZoom($(window).width() < 660 ? this.instance.getZoom() : this.instance.getZoom() - 1);
    } else if ($(window).width() < 660) {
      var centerBoundry = new this.googleMap.LatLngBounds().extend(this.latlng);

      setTimeout(function(){
        self.instance.fitBounds(centerBoundry);
        self.instance.setZoom(self.instance.getZoom() - 7);
      }, 100);
    }
  },

  bindMarkerOpen: function(infoBoxObject, markerObject) {
    var self = this;

    this.bindTogglePoiInfobox(infoBoxObject, markerObject);
    this.googleMap.event.addListener(markerObject, 'click', function(marker, i){
      if (neighborhoodSettings.layout == 4) {
        var $poiItem = $('[data-poi-id=' + markerObject.id + ']');
        var scrollTimeout = self.$map.data('fixed') ? 0 : 600;

        if ($poiItem.length) {
          $('html, body').animate({
            scrollTop: $poiItem.offset().top - self.$map.outerHeight()
          }, 200);
        }

        setTimeout(function(){
          self.openWindow.close();
          self.openMarker(infoBoxObject, markerObject);
        }, scrollTimeout);
      } else {
        self.openWindow.close();
        self.openMarker(infoBoxObject, markerObject);
      }
    });
  },

  openMarker: function(infoBoxObject, markerObject, callback) {
    // -- Close all InfoBoxes except Main
    if (this.openWindow && !this.openWindow.isMain) {
      this.openWindow.close();
    }

    // -- Open new InfoBox
    var $listingItem = this.$poiToggleBox.filter('[data-poi-id=' + markerObject.id + ']');
    infoBoxObject.open(this.instance, markerObject);
    this.$poiToggleBox.removeClass('neighborhood__poi-category-link--active');
    $listingItem.addClass('neighborhood__poi-category-link--active');
    this.openWindow = infoBoxObject;

    if ($listingItem.parent().data('js-hook') == 'poi-hidden' && !$listingItem.parent().is(':visible')) {
      $('#load-all-poi').trigger('click');
    }
  },

  bindControls: function() {
    var self = this;

    // -- Adjust POI Visibility when selecting a filter
    if (!mapSettings.loadAll) {
      var $firstPoi = this.$poiFilter.first();

      if (neighborhoodSettings.layout == 4) {
        this.$poiFilter.each(function(){
          if ($(this).data('poi') != 'all') {
            $firstPoi = $(this);

            return false;
          }
        });
      }

      $firstPoi.attr('data-selected', true);
    }

    this.$poiFilter.click(function(e){
      e.preventDefault();

      self.currentCategory = $(this).data('poi');
      self.poiVisibility(self.currentCategory, true);
    });

    // -- Map click closes all windows
    this.googleMap.event.addListener(self.instance, 'click', function(){
      self.mainInfoBox.close();
      if (self.openWindow) {
        self.openWindow.close();
      }
    });

    // -- Zoom In Control
    this.$zoomIn.unbind().click(function(e){
      e.preventDefault();
      self.instance.setZoom(self.instance.getZoom() + self.zoomIncrement);
    });

    // -- Zoom Out Control
    this.$zoomOut.unbind().click(function(e){
      e.preventDefault();
      self.instance.setZoom(self.instance.getZoom() - self.zoomIncrement);
    });

    // -- Refresh Control
    this.$refresh.unbind().click(function(e){
      e.preventDefault();

      if (!mapSettings.loadAll) {
        self.currentCategory = self.defaultCategory;
      }

      if (neighborhoodSettings.layout == 4) {
        var odd = true;

        self.$poiCategory.each(function(){
          var $contentCell = $(this).find('[data-content-cell]');
          $(this).find('[data-content-cell]').remove();

          if (odd) {
            $(this).append($contentCell);
          } else {
            $(this).prepend($contentCell);
          }

          odd = !odd;
        }).show();
      } else if (mapSettings.loadAll) {
        self.$poiCategory.show();
      }

      self.loadMap();
    });
  },

  bindTogglePoiInfobox: function(infoBoxObject, markerObject) {
    var self = this;
    var togglePoiActiveClass = 'neighborhood__poi-category-link--active';
    this.$poiToggleBox.filter('[data-poi-id=' + markerObject.id + ']').click(function(e){
      e.preventDefault();
      if ($(window).width() >= 808 || neighborhoodSettings.layout == 4) {
        self.poiVisibility(markerObject.category);
        self.openWindow.close();
        self.openMarker(infoBoxObject, markerObject);
        self.$poiToggleBox.removeClass(self.poiActiveClass);
        $(this).addClass(self.poiActiveClass);
        self.instance.panTo(new self.googleMap.LatLng(markerObject.position.lat(), markerObject.position.lng()));
        $('html, body').stop().animate({
          scrollTop: self.$mapCanvas.offset().top
        }, 300);
      }
    });
  },

  setOptions: function(){
    this.latlng = new google.maps.LatLng(mapSettings.lat, mapSettings.lng);

    // -- Point of Interest Infobox Options Object
    this.poiOptions = {
      content: null, // -- Set by drawPoint
      disableAutoPan: false,
      alignBottom: true,
      maxWidth: 0,
      pixelOffset: new google.maps.Size(0, -30),
      zIndex: null,
      boxClass: "map__infobox",
      infoBoxClearance: new google.maps.Size(1, 1),
      isHidden: false,
      pane: "floatPane",
      enableEventPropagation: true
    };

    // -- Pinpoint Infobox Options Object
    this.pinpointOptions = {
      content: this.mainInfoboxHTML,
      disableAutoPan: false,
      maxWidth: 0,
      pixelOffset: new google.maps.Size(-70, -160),
      zIndex: 9999,
      boxStyle: {},
      boxClass: "map__infobox",
      closeBoxMargin: "-20px 43px 0 0",
      closeBoxURL: "",
      infoBoxClearance: new google.maps.Size(1, 1),
      isHidden: false,
      pane: "floatPane",
      enableEventPropagation: true
    };

    // -- Map Options Object
    this.mapOptions = {
      zoom: 14,
      minZoom: 5,
      maxZoom: 25,
      scrollwheel: false,
      center: this.latlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      disableDefaultUI: true,
      styles: this.mapStyles
    };
  },

  constructMapIcons: function() {
    var self = this;
    var $icons = $('[id^=poi_icon]');

    $icons.each(function(){
      $(this).find('circle').first().css({
        fill: $(this).data('fill')
      });

      var xml  = new XMLSerializer().serializeToString($(this).find('svg')[0]);
      var data = "data:image/svg+xml;base64," + btoa(xml);
      var img  = new Image();

      self.icons[$(this).data('category')] = data;
    });
  },

  init: function() {
    this.dom();
    this.definitions();
    this.constructMapIcons();
    this.onGoogleLoad(this.loadMap);
  }
}

$(function() {
  if ($('#map_canvas').length) {
    neighborhoodMap.init();
  }
});


var mapStyles = [ {
  "featureType": "all",
  "elementType": "labels.text.fill",
  "stylers": [ {
    "visibility": "on"
  }, {
    "color": "#858585"
  } ]
}, {
  "featureType": "landscape",
  "elementType": "geometry.fill",
  "stylers": [ {
    "visibility": "on"
  }, {
    "color": "#f2eeeb"
  } ]
}, {
  "featureType": "poi",
  "elementType": "all",
  "stylers": [ {
    "visibility": "off"
  } ]
}, {
  "featureType": "poi.park",
  "elementType": "geometry.fill",
  "stylers": [ {
    "visibility": "on"
  }, {
    "color": "#ece6da"
  } ]
}, {
  "featureType": "road",
  "elementType": "geometry.fill",
  "stylers": [ {
    "visibility": "on"
  }, {
    "color": "#ffffff"
  } ]
}, {
  "featureType": "road.highway",
  "elementType": "all",
  "stylers": [ {
    "visibility": "simplified"
  } ]
}, {
  "featureType": "road.highway",
  "elementType": "labels",
  "stylers": [ {
    "visibility": "off"
  } ]
}, {
  "featureType": "transit",
  "elementType": "geometry.fill",
  "stylers": [ {
    "visibility": "on"
  }, {
    "color": "#ffffff"
  } ]
}, {
  "featureType": "transit",
  "elementType": "labels",
  "stylers": [ {
    "visibility": "off"
  } ]
}, {
  "featureType": "transit.station",
  "elementType": "all",
  "stylers": [ {
    "visibility": "off"
  } ]
}, {
  "featureType": "water",
  "elementType": "geometry.fill",
  "stylers": [ {
    "visibility": "on"
  }, {
    "color": "#c3e8f0"
  } ]
} ];

(function(){

  var neighborhood = {
    a: {
      dom: function() {
        this.$loadAll     = $('#load-all-poi');
        this.$poiList     = $('[data-js-hook="poi-list"]');
        this.$loadLocal   = $('[data-js-hook="load-local-poi"]');
        this.$poi         = $('[data-js-hook="poi-hidden"]');
      },

      loadAll: function() {
        var self = this;

        this.$loadAll.click(function(e){
          e.preventDefault();
          var $this = $(this);

          self.$poi.slideToggle(200, function(){
            $this.text(self.$poi.first().is(':visible') ? 'Load Less' : 'Load All');
          });
        });
      },

      loadLocal: function() {
        var self = this;
        this.$loadLocal.click(function(e){
          e.preventDefault();
          $(this).toggleClass('neighborhood__poi-category-header--active');
          self.$poiList.filter('[data-category="' + $(this).data('category') + '"]').slideToggle(200);
        });
      },

      ready: function() {
        this.dom();
        this.loadAll();
        this.loadLocal();
      }
    },

    b: {
      dom: function() {
        this.$loadLocal             = $('[data-js-hook="load-local-poi"]');
        this.$poi                   = $('[data-js-hook="poi-hidden"]');
        this.$poiFilter             = $('[data-js-hook="poi-filter"]');
        this.$categorySelectLink    = $('#category-select-link');
        this.$categorySelectOptions = $('#category-select-options');
        this.$poiCategory           = $('[data-js-hook="poi-category"]');
      },

      data: {
        activePoiFilterClass: 'map-a__cat-link--active'
      },

      loadLocal: function() {
        var self = this;

        this.$loadLocal.click(function(e){
          e.preventDefault();
          var $this = $(this);
          var $poi = self.$poi.filter('[data-category="' + $(this).data('category') + '"]');

          $poi.slideToggle(200, function(){
            $this.find('[data-js-hook="load-text"]').text($poi.first().is(':visible') ? '- Load Less' : '+ Load ALl');
          });
        });
      },

      /*
        Function relies on map.js assigning `data-selected` attribute
        values to category anchors on click.
      */
      injectCategoryHTML: function() {
        var self = this;
        var activeCategoryHTML = '';

        setTimeout(function(){
          if (self.$poiFilter.filter('[data-selected=true]').length) {
            activeCategoryHTML = self.$poiFilter.filter('[data-selected=true]').html();
          } else if (self.$poiFilter.filter('[data-poi="all"]').length) {
            activeCategoryHTML = self.$poiFilter.filter('[data-poi="all"]').html();
          }
          else {
            activeCategoryHTML = self.$poiFilter.eq(0).html();
          }

          self.$categorySelectLink.html(activeCategoryHTML.replace('poi-filter', 'poi-select-toggle'));
        }, 500);
      },

      categorySelect: function() {
        var self = this;

        // -- Toggle Category Options
        this.$categorySelectLink.click(function(e){
          e.preventDefault();
          self.$categorySelectOptions.slideToggle(100);
        });

        // -- Category Selection
        this.$poiFilter.click(function(e){
          if ($(this).data('poi') != 'all') {
            var $poiCat = self.$poiCategory.hide().filter('[data-category="' + $(this).data('poi') + '"]');
          } else {
            var $poiCat = self.$poiCategory;
          }

          self.$poiFilter.attr('data-selected', false).removeClass(self.data.activePoiFilterClass);
          $(this).attr('data-selected', true).addClass(self.data.activePoiFilterClass);
          self.injectCategoryHTML();
          self.$categorySelectLink.trigger('click');
          $poiCat.show();
        });
      },

      ready: function() {
        this.dom();
        this.loadLocal();
        this.categorySelect();
        this.injectCategoryHTML();
      }
    },

    c: {
      dom: function() {
        this.$map                   = $('#map');
        this.$mapBody               = $('#map-body');
        this.$poi                   = $('[data-js-hook="poi-hidden"]');
        this.$poiFilter             = $('[data-js-hook="poi-filter"]');
        this.$poiList               = $('#poi-list');
        this.$categorySelectLink    = $('#category-select-link');
        this.$categorySelectOptions = $('#category-select-options');
        this.$poiCategory           = $('[data-js-hook="poi-category"]');
        this.$backToTop             = $('#back-to-top');
      },

      data: {
        activePoiFilterClass: 'map-c__cat-link--active'
      },

      /*
        Function relies on map.js assigning `data-selected` attribute
        values to category anchors on click.
      */
      injectCategoryHTML: function() {
        var self = this;
        var activeCategoryHTML = '';

        setTimeout(function(){
          if (self.$poiFilter.filter('[data-selected=true]').length) {
            activeCategoryHTML = self.$poiFilter.filter('[data-selected=true]').html();
          } else {
            activeCategoryHTML = self.$poiFilter.filter('[data-poi="all"]').html();
          }

          self.$categorySelectLink.html(activeCategoryHTML.replace('poi-filter', 'poi-select-toggle'));
        }, 500);
      },

      categorySelect: function() {
        var self = this;

        // -- Toggle Category Options
        this.$categorySelectLink.click(function(e){
          e.preventDefault();
          self.$categorySelectOptions.slideToggle(100);
        });

        // -- Category Selection
        this.$poiFilter.click(function(e){
          if ($(this).data('poi') != 'all') {
            var $poiCat = self.$poiCategory.hide().filter('[data-category="' + $(this).data('poi') + '"]');
          } else {
            var $poiCat = self.$poiCategory;
          }

          self.$poiFilter.attr('data-selected', false).removeClass(self.data.activePoiFilterClass);
          $(this).attr('data-selected', true).addClass(self.data.activePoiFilterClass);
          self.injectCategoryHTML();
          self.$categorySelectLink.trigger('click');
          self.$poiCategory.hide();

          var odd = true;
          $poiCat.each(function(){
            var $contentCell = $(this).find('[data-content-cell]');
            $(this).find('[data-content-cell]').remove();

            if (odd) {
              $(this).append($contentCell);
            } else {
              $(this).prepend($contentCell);
            }

            odd = !odd;
          }).show();

          // $('html, body').animate({
          //   scrollTop: self.$poiList.offset().top - self.$map.outerHeight()
          // }, 200);
        });


      },

      ready: function() {
        var self = this;

        this.dom();
        this.injectCategoryHTML();
        this.categorySelect();

        var mapPlaceholder = $('<div id="map-placeholder"></div>');
        this.$map.after(mapPlaceholder);

        this.$backToTop.click(function(e){
          e.preventDefault();

          $('html, body').animate({
            scrollTop: 0
          }, 200);
        });

        $(window).scroll(function(){
          if (self.$map.data('fixed') && self.$map.offset().top <= mapPlaceholder.offset().top) {
            self.$map.data('fixed', false);

            self.$map.removeClass('map-c__fixed');
            self.$backToTop.removeClass('fixed');

            if ($(window).width() > 808) {
              setTimeout(function(){
                neighborhoodMap.loadMap(false, true);
              }, 500);
            }

            mapPlaceholder.height(0);
          }

          if (!self.$map.data('fixed') && (self.$map.offset().top - $(window).scrollTop()) < 0) {
            self.$map.data('fixed', true);

            self.$map.addClass('map-c__fixed');
            self.$backToTop.addClass('fixed');

            if ($(window).width() > 808) {
              setTimeout(function(){
                neighborhoodMap.loadMap(false, true);
              }, 500);
            }

            mapPlaceholder.height(self.$map.outerHeight());

            setTimeout(function(){
              mapPlaceholder.animate({
                height: self.$map.outerHeight()
              }, 80);
            }, 50);
          }
        });
      }
    },

    ready: function() {
      switch (parseInt(neighborhoodSettings.layout)) {
        case 1:
          this.a.ready();
          break;
        case 2:
        case 3:
          this.b.ready();
          break;
        case 4:
          this.c.ready();
      }
    }
  }

  $(function(){
    if (typeof neighborhoodSettings !== 'undefined') {
      neighborhood.ready();
    }
  });
})();

$(document).ready(function() {
  setupShareThis();
});

function setupShareThis(){
  var shareContainer = $('#share-this-popup');
  var shareLink      = $('#share-link');
  var shareLoader    = $('#share-loader');
  var activeClass    = 'share-this-popup--show';

  shareContainer.data('loaded', '0');

  shareLink.on('click',function(e){
    e.preventDefault();
    e.stopPropagation();

    //If we don't have any Share This content on the page already, fetch it via AJAX
    if (shareContainer.data('loaded') == '0') {
      //indicate that it's loading...
      shareLoader.show();
      shareLink.css('opacity', 0);

      //mark Share This as loaded so we won't load it via AJAX again unless page is refreshed
      shareContainer.data('loaded', '1');

      //If user overrode defaults in the HTML markup, use the override values here
      var sUrl = shareContainer.data('url') || '';
      var sTweetFilter = shareContainer.data('tweet-filter') || 'GLOBAL';

      //fetch the Share This content via AJAX
      shareContainer.load(shareContainer.data('script'), { 'url': sUrl, 'tweet_filter': sTweetFilter }, function() {
        shareContainer.addClass(activeClass);
        //remove the loading indicator
        shareLoader.hide();
        shareLink.css('opacity', 1);
      });
    }
    else {
      //We've already fetched Share This content for this page, so just show it
      shareContainer.toggleClass(activeClass);
    }
  });

  $('body').click(function() {
    //if the "SHARE" tooltip is visible, then close it
    if (shareContainer.hasClass(activeClass)) {
      shareContainer.toggleClass(activeClass);
    }
  });
}

(function(){
  var skipStep = {
    domCache: function() {
      this.leaseObject  = {};
      this.picker       = null;
      this.$bindEl      = null;
      this.$confirm     = null;
      this.$table       = $('[data-js-hook="panel"]').filter('[data-type="check-availability"]');
      this.$unitSelect  = $('[data-js-hook="lease-now"]');
      this.$leaseButton = $('[data-js-hook="lease-button"]');
      this.$leaseTerm   = $('[data-js-hook="lease-term-input"]');
    },

    injectBindElement: function(callback) {
      var self = this;
      var bindEl = document.createElement('div');
      bindEl.id = 'picker-bind';
      self.$bindEl = $(bindEl);
      $('body').prepend(self.$bindEl);
    },

    bindUnitSelect: function() {
      var self = this;

      // -- Re-build leaseObject on change
      this.$unitSelect.click(function(e){
        e.preventDefault();
        e.stopPropagation();
        var lease_term = null;

        if ($(this).data('lease-term')) {
          lease_term = self.$leaseTerm.filter('[data-unit="' + $(this).data('unit') + '"]:checked').val();
        }

        self.leaseObject.id          = $(this).data('id-value');
        self.leaseObject.start       = $(this).data('availability-start');
        self.leaseObject.end         = $(this).data('availability-end');
        self.leaseObject.url         = $(this).attr('href');
        self.leaseObject.date_format = $(this).data('date-format');
        self.leaseObject.lease_term  = lease_term;

        self.openPickerInstance();
      });
    },

    confirmUrlInject: function() {
      if (this.$confirm) {
        this.$confirm.attr('href', this.leaseObject.url.replace('{lease_term}', this.leaseObject.lease_term).replace('{unit_id}', this.leaseObject.id).replace('{date}', this.picker.get('highlight', this.leaseObject.date_format)));
      }
    },

    pickadateInit: function() {
      this.picker = this.$bindEl.pickadate({
        closeOnSelect: false
      }).data('pickadate').stop();
    },

    pickadateHTMLInject: function() {
      // -- Custom Header Markup
      var customHeader = '<h1 id="custom-picker-header" class="picker__custom-header">\
                            Desired Move-in Date\
                          </h1>';

      // -- Custom Confirm Markup
      var customConfirm = '<div id="custom-picker-confirm" class="picker__confirm-wrap">\
                            <a target="_blank" id="picker-confirm" class="picker__confirm" href="#">\
                              Lease Now\
                            </a>\
                           </div>';

      // -- Remove custom markup before re-injection
      $('#custom-picker-header').remove();
      $('#custom-picker-confirm').remove();

      // -- Inject (or re-inject)
      $('.picker__frame').prepend(customHeader).append(customConfirm);

      // -- Bind (or re-bind) confirm button
      this.$confirm = $('#picker-confirm');
      this.bindConfirmButton();
    },

    bindConfirmButton: function($el) {
      var self = this;
      if (this.$confirm) {
        this.$confirm.unbind().bind('click', function(){
          if (self.picker) {
            self.picker.close();
          }
        });
      }
    },

    // -- Bind pop-calendar click event to open Pickadate
    openPickerInstance: function() {
      var self = this;

      // -- Retrieve & format selected unit's availability start & end date
      if (self.leaseObject.start && self.leaseObject.end) {
        var start = self.leaseObject.start.split('-');
        var end = self.leaseObject.end.split('-');
        start = start.map(function(num){return parseInt(num)});
        end = end.map(function(num){return parseInt(num)});
        // -- Re-adjust Month for JS Date Format
        start[1] = parseInt(start[1]) - 1;
        end[1] = parseInt(end[1]) - 1;
      }

      // -- Destroy and rebuild Picker w/ new start & end
      self.picker
        .stop()
        .start()
        .set('disable', [ { from: start, to: end } ])
        .set('disable', 'flip')
        .set('select', start)
        .on({
          open: function(){
            self.pickadateHTMLInject();
            self.confirmUrlInject();
          },
          set: function() {
            self.confirmUrlInject();
          },
          close: function() {
            self.picker.stop();
          }
        })
        .open();
    },

    // -- skipStep object kickoff
    init: function() {
      this.domCache();

      if (parseInt(this.$table.data('skip-step-init'))) {
        this.injectBindElement();
        this.bindUnitSelect();
        this.pickadateInit();
      }
    }
  }

  $(function(){
    skipStep.init();
  });
})();

//# sourceMappingURL=custom.js.map
